@if (!editableGallery && !editableImage) {
    <web-widget-breadcrumbs [widget]="widget" [isInSpecificSection]="isSpecific"></web-widget-breadcrumbs>
    <div class="panel-options-body overflow-wrapper">
        <div class="form form-horizontal">
            <div class="form-row mb-20">
                <div class="form-group">
                    <div>
                        <label>{{ "gallery_type" | translate }}</label>
                        <a (click)="editGallery(data.value.options)" class="dotted pull-right">{{
                            "theme_settings_customize" | translate
                        }}</a>
                    </div>
                    <div>
                        <select class="form-control" (change)="setGalleryType($event)">
                            @for (opt of galleryTypesOptions; track opt) {
                                <option [value]="opt.type" [selected]="galleryType.value === opt.type">
                                    {{ opt.label | translate }}
                                </option>
                            }
                        </select>
                    </div>
                </div>
            </div>
            <sp-file-manager
                #fm
                [files]="images.value || []"
                [isLink]="true"
                [previewType]="PreviewType.IMAGE_MULTIPLE"
                [displayOnly]="[DirectoryItemCategory.Image]"
                [fmSourceType]="FmSourceType.LANDING"
                [multiSelect]="true"
                (setFileEvent)="setImages($event)"
                (updateFilesEvent)="removeImage($event)"
                (replaceFileEvent)="replaceImage($event)"
            >
                @if (!images.value?.length) {
                    <sp-defautl-upload-button
                        stockImagesDropdown
                        [disabled]="buttonDisabled"
                        (unsplashRequested)="openUnsplashModal()"
                    ></sp-defautl-upload-button>
                }
                @if (images.value?.length) {
                    <sp-link-upload-button
                        stockImagesDropdown
                        slot="add-more-files"
                        [label]="'add_images' | translate"
                        [disabled]="buttonDisabled"
                        (unsplashRequested)="openUnsplashModal()"
                    ></sp-link-upload-button>
                }
                <ng-template
                    #previewTemplate
                    let-files="files"
                    let-buildFilePreviewUrlsFn="buildFilePreviewUrlsFn"
                    let-replaceFileFn="replaceFileFn"
                >
                    <div
                        class="thumbnail-container mb-20"
                        [sortablejs]="sortableImages"
                        [sortablejsOptions]="sortableOptions"
                    >
                        @for (file of images.value || []; track file; let i = $index) {
                            <div class="thumbnail-item">
                                <sp-control-handle
                                    [controlHandleImagePreviewSources]="buildFilePreviewUrlsFn(files[i])"
                                    [galleryMode]="true"
                                    (replaceActionEvent)="handleImageReplace($event, i, replaceFileFn)"
                                    (removeActionEvent)="removeImage(i)"
                                    (imageEditEvent)="showEditImageModal(i)"
                                    (settingActionEvent)="editImage(file, i)"
                                    [isDisableEditor]="(userId$ | async) !== imageOwnerUserId(i)"
                                >
                                </sp-control-handle>
                            </div>
                        }
                    </div>
                </ng-template>
            </sp-file-manager>
            @if (images.value?.length) {
                <div class="form-group mb-20 mt-20">
                    <div class="col-xs-6">
                        <label class="control-label">
                            {{ "control_width" | translate }}
                            <img
                                [tooltip]="videoWidth"
                                class="font-icon"
                                src="./assets/img/websites/lpc-help-icon.svg"
                            />
                            <ng-template #videoWidth>
                                {{ "img_control_max_width" | translate }}
                            </ng-template>
                        </label>
                    </div>
                    <div class="col-xs-6 video-width-control">
                        @if (maxWidth.value !== columnWidth) {
                            <img
                                class="refresh-width-btn"
                                src="./assets/img/websites/lpc-return-icon.svg"
                                alt="refresh-icon"
                                [tooltip]="refreshImageWidthTooltip"
                                (click)="refreshMaxWidth()"
                            />
                        }
                        <ng-template #refreshImageWidthTooltip>
                            {{ "refresh_width_tooltip" | translate }}
                        </ng-template>
                        <sp-input-num
                            suffixText="px"
                            [min]="200"
                            [max]="columnWidth"
                            [value]="maxWidth.value"
                            (valueChange)="setMaxWidth($event)"
                        >
                        </sp-input-num>
                    </div>
                </div>
                <div class="form-group">
                    <label class="control-label col-xs-7">
                        {{ "control_content_alignment" | translate }}
                    </label>
                    <div class="col-xs-5">
                        <sp-radio-group
                            [selected]="horizontalAlign.value"
                            [type]="ERadioGroupType.horizontalPosition"
                            (changeSelectedEvent)="setHorizontalAlign($event)"
                        ></sp-radio-group>
                    </div>
                </div>
            }
            <div class="form-group mb-0">
                <div class="col-xs-12">
                    <hr class="panel-options-divider" />
                </div>
            </div>
            <web-widget-hide-settings
                [hideOnDesktop]="hideOnDesktop.value"
                [hideOnTablet]="hideOnTablet.value"
                [hideOnMobile]="hideOnMobile.value"
                (hideOnDesktopChange)="setHideOnDesktop($event)"
                (hideOnTabletChange)="setHideOnTablet($event)"
                (hideOnMobileChange)="setHideOnMobile($event)"
            ></web-widget-hide-settings>
            <div class="form-group mb-0">
                <div class="col-xs-12">
                    <hr class="panel-options-divider" />
                </div>
            </div>
            <div class="mt-20">
                <web-custom-id [displayId]="displayId" (valueChangeEvent)="updateWidgetDisplayId($event)">
                </web-custom-id>
            </div>
        </div>
    </div>
} @else {
    @if (editableGallery && !editableImage) {
        <web-gallery-settings
            (formReady)="addChildForm('options', $event)"
            (valueChange)="patchOptions($event)"
            [galleryType]="galleryType.value"
            [item]="editableGallery"
            [isSynchronizeStyle]="isSynchronizeStyle.value"
            (synchronizeStyleToggle)="setSynchronizeStyle()"
            (saveEvent)="saveAndClose($event)"
            (cancelEvent)="editGallery(null)"
        >
        </web-gallery-settings>
    } @else {
        @if (editableImage) {
            <web-image-settings
                [item]="editableImage"
                (cancelEvent)="editImage(null)"
                (saveEvent)="setImageData($event)"
            >
            </web-image-settings>
        }
    }
}
